import { createReducer, Action, on } from '@ngrx/store';

import { EmbeddedActions } from './embedded.actions';
import { EmbeddedState } from './embedded.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: EmbeddedState = {
  loading: false,
  collapsedTopics: {},
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      EmbeddedActions.LoadDeal,
      (state): EmbeddedState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      EmbeddedActions.LoadDealSuccess,
      (state, action): EmbeddedState => ({ ...state, loading: false, deal: action.deal })
    ),
    on(
      EmbeddedActions.LoadDealFail,
      (state, action): EmbeddedState => ({ ...state, loading: false, error: action.error })
    ),
    on(
      EmbeddedActions.SetCollapsedTopics,
      (state, action): EmbeddedState => ({ ...state, collapsedTopics: action.collapsedTopics })
    )
  )
);

export function reducer(state: EmbeddedState | undefined, action: Action) {
  return featureReducer(state, action);
}
